const ROOT = "containers/InfinityTableTest/"

export const REQUEST_ORDER = "REQUEST_ORDER"
export const RECEIVE_ORDER = ROOT + "RECEIVE_ORDER"
export const CANCEL_COLI = ROOT + "CANCEL_COLI"
export const RECEIVE_CANCEL_COLI = ROOT + "RECEIVE_CANCEL_COLI"
export const CLEAR_ORDER = ROOT + "CLEAR_ORDER"

export const PAGE_SIZE = 15

export function getPageOfIndex(index) {
  return Math.floor(index / PAGE_SIZE) + 1
}
